// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__EwVYi","icons":"Footer_icons__ZW8St"};